import { useEffect } from 'preact/hooks'
import { useSignal } from '@preact/signals'
import { Link } from 'wouter-preact'

import { projectsState, getProjects } from 'state'
import { Input, Typography } from 'components'
import { ChevronLeftIcon } from 'components/UI'
import { NewSmartContractModal } from 'pages/components'
import {
	isNewSmartContractModalOpen,
	setSmartContractModalState
} from 'pages/home/state'

import { DAppCard, NewSmartContractCard } from './components'

const DAppsPage = () => {
	const searchValue = useSignal('')
	const isLoading = useSignal(true)

	const hasProjects = !!projectsState.value?.length

	useEffect(() => {
		getProjects().then(() => {
			isLoading.value = false
		})

		return () => {
			setSmartContractModalState(false)
		}
	}, [isLoading])

	const filteredDApss = projectsState.value.filter(dApp =>
		dApp.name.toLowerCase().includes(searchValue.value.toLowerCase())
	)

	return (
		<div class='min-w-[640px] flex-1'>
			<div class='pr-0 sm:pr-8'>
				<Link
					class='mb-10 flex items-center gap-4 text-black-400 hover:text-product'
					href='/'
				>
					<ChevronLeftIcon />
					<Typography
						class='mt-[1px]'
						color='text-black-400'
						text='Back to Home'
						variant='text3'
					/>
				</Link>

				<Typography
					class='mb-6'
					color='text-black-100'
					text='Your dApps'
					variant='h4'
				/>

				{!isLoading.value && hasProjects && (
					<>
						<div class='grid-span2 my-5 mb-6 flex w-full xl:w-[360px]'>
							<Input
								id='search'
								onInput={value => {
									searchValue.value = value
								}}
								placeholder='Find a dApp...'
								type='text'
								value={searchValue}
								fullWidth
							/>
						</div>

						{filteredDApss.map(dApp => (
							<DAppCard dApp={dApp} key={dApp.id} />
						))}
					</>
				)}

				{!isLoading.value && !hasProjects && <NewSmartContractCard />}
			</div>

			{isNewSmartContractModalOpen.value && (
				<NewSmartContractModal
					isOpen={isNewSmartContractModalOpen.value}
					onClose={() => setSmartContractModalState(false)}
				/>
			)}
		</div>
	)
}

export { DAppsPage }
